let html = `<div class="ad-fork">
    <div class="ad-fork__card">
        <div class="ad-fork__title">#{ad_fork_title}</div>
        <div class="ad-fork__subtitle">#{ad_fork_subtitle}</div>

        <div class="ad-fork__options">
            <div class="ad-fork__option selector" data-action="ads">
                <div class="ad-fork__option-title">#{ad_fork_free_title}</div>
                <div class="ad-fork__option-text">#{ad_fork_free_text}</div>
                <div class="ad-fork__option-button">#{ad_fork_free_btn}</div>
            </div>

            <div class="ad-fork__option ad-fork__option--paid selector" data-action="paid">
                <div class="ad-fork__option-title">#{ad_fork_paid_title}</div>
                <div class="ad-fork__option-text">#{ad_fork_paid_text}</div>
                <div class="ad-fork__option-day">#{ad_fork_paid_day}</div>
                <div class="ad-fork__option-button ad-fork__option-button--accent">#{ad_fork_paid_btn}</div>
            </div>
        </div>

        <div class="ad-fork__footer">#{ad_fork_footer}</div>
        <div class="ad-fork__note">#{ad_fork_note}</div>
    </div>
</div>`

export default html
